import React from 'react';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaFacebookF, FaTwitter, FaLinkedinIn } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

function Footer() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#F4F4FA] text-black">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-8 items-stretch">
          {/* Colonne 1 - Logo + description */}
          <div className="sm:col-span-2 md:col-span-3 lg:col-span-1">
            <div className="mb-4">
              <img 
                src="/logo.png" 
                alt="SOCABEG Logo" 
                className="h-12 mb-4"
              />
              <p className="text-black">
                Société d'Aménagement de Bâtiment et d'Etudes Générales - {t('footer.description')}
              </p>
              
              {/* Réseaux sociaux */}
              <div className="flex items-center gap-4 mt-4">
                <a href="https://www.facebook.com/socabeg" target="_blank" rel="noopener noreferrer" className="text-socabeg-blue hover:text-socabeg-blue/80 transition-colors duration-200"><FaFacebookF /></a>
                <a href="https://www.twitter.com/socabeg" target="_blank" rel="noopener noreferrer" className="text-socabeg-blue hover:text-socabeg-blue/80 transition-colors duration-200"><FaTwitter /></a>
                <a href="https://www.linkedin.com/company/socabeg" target="_blank" rel="noopener noreferrer" className="text-socabeg-blue hover:text-socabeg-blue/80 transition-colors duration-200"><FaLinkedinIn /></a>
              </div>
            </div>
          </div>

          {/* Colonne 2 - Contact */}
          <div>
            <h4 className="font-semibold mb-4">{t('footer.contact')}</h4>
            <ul className="space-y-3">
              <li className="flex items-start">
                <FaPhoneAlt className="mt-1 mr-2 text-socabeg-gold" />
                <div>
                  <div>+221 33 889 35 35</div>
                  <div>+221 33 889 30 99</div>
                  <div>+221 70 825 55 22</div>
                </div>
              </li>
              <li className="flex items-center">
                <FaEnvelope className="mr-2 text-socabeg-gold" />
                infos@socabeg.com
              </li>
              <li className="flex items-start">
                <FaMapMarkerAlt className="mt-1 mr-2 text-socabeg-gold flex-shrink-0" />
                <span>Fann-Hock – Corniche face Cour Suprême, BP 1270, Dakar, Sénégal</span>
              </li>
            </ul>
          </div>

          {/* Colonne 3 - Liens utiles */}
          <div>
            <h4 className="font-semibold mb-4">{t('footer.usefulLinks')}</h4>
            <ul className="space-y-2">
              <li><Link to="/btp" className="hover:text-socabeg-blue transition-colors duration-200">{t('footer.construction')}</Link></li>
              <li><Link to="/promotion-immobiliere" className="hover:text-socabeg-blue transition-colors duration-200">{t('footer.realEstate')}</Link></li>
              <li><Link to="/mines" className="hover:text-socabeg-blue transition-colors duration-200">{t('footer.mining')}</Link></li>
            </ul>
          </div>

          {/* Colonne 4 - Le Groupe */}
          <div className="h-full flex flex-col">
            <h4 className="font-semibold mb-4">{t('footer.group')}</h4>
            <ul className="space-y-2">
              <li><Link to="/a-propos" className="hover:text-socabeg-blue transition-colors duration-200">{t('footer.about')}</Link></li>
              <li><Link to="/contact" className="hover:text-socabeg-blue transition-colors duration-200">{t('footer.contact')}</Link></li>
              <li><Link to="/carrieres" className="hover:text-socabeg-blue transition-colors duration-200">{t('footer.join')}</Link></li>
            </ul>
          </div>

          {/* Colonne 5 - LEGAL */}
          <div className="h-full flex flex-col">
            <h4 className="font-semibold mb-4">{t('footer.legal_column')}</h4>
            <ul className="space-y-2">
              <li><Link to="/mentions-legales" className="hover:text-socabeg-blue transition-colors duration-200">{t('footer.legal')}</Link></li>
              <li><Link to="/politique-de-confidentialite" className="hover:text-socabeg-blue transition-colors duration-200">{t('footer.privacy')}</Link></li>
            </ul>
          </div>

        </div>

      </div>
      
      {/* Copyright - pleine largeur sur fond gris */}
      <div className="bg-[#F4F4FA] text-center text-sm text-black py-4 border-t border-gray-300 mt-12">
        <div className="container mx-auto px-4">
          &copy; {currentYear} Groupe SOCABEG | {t('footer.rights')}
        </div>
      </div>

      {/* Powered by - pleine largeur sur fond blanc */}
      <div className="bg-white text-center text-sm text-black py-2">
        <div className="container mx-auto px-4">
          Powered by{' '}
          <a
            href="https://taphacoobams.vercel.app/"
            target="_blank"
            rel="noopener noreferrer"
            className="font-semibold text-socabeg-blue hover:underline"
          >
            MMS
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;